import API from "./axios";

export async function searchCities(input) {
  if (!input || input.trim().length < 2) {
    return [];
  }

  try {
    const { data } = await API.get("/location/search_cities", {
      params: { input: input.trim() }
    });

    return data.predictions || [];
  } catch (error) {
    console.error("Error searching cities:", error);
    return [];
  }
}

export async function searchAddresses(input, city = null) {
  if (!input || input.trim().length < 1) {
    return [];
  }

  try {
    const params = { input: input.trim() };
    if (city) {
      params.city = city.trim();
    }

    const { data } = await API.get("/location/search_address", { params });

    return data.predictions || [];
  } catch (error) {
    console.error("Error searching addresses:", error);
    return [];
  }
}

export async function getPlaceDetails(placeId) {
  if (!placeId) {
    throw new Error("Place ID is required");
  }

  try {
    const { data } = await API.get("/location/place_details", {
      params: { placeId }
    });

    return data;
  } catch (error) {
    console.error("Error getting place details:", error);
    throw error;
  }
}

export async function calculateDistance(fromPlaceId, toPlaceId) {
  if (!fromPlaceId || !toPlaceId) {
    throw new Error("Both place IDs are required");
  }

  try {
    const { data } = await API.post("/location/get_distance", {
      fromPlaceId,
      toPlaceId
    });

    return data;
  } catch (error) {
    console.error("Error calculating distance:", error);
    throw error;
  }
}
